import { Button, Divider, Popover, Select, Space, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    grispiSubscriptionModal,
    subscriptionFeatureMap
} from '../../../containers/subscription/SubscriptionController';
import { getTranslatedText } from '../../../services/translate-plugin/translate-plugin';
import { usePluginStore } from '../../../store/RootStoreContext';
import { grispiNotification } from '../../../store/useNotificationStore';

const ChatMessageTranslateDropDown = ({
    handleChange,
    messageText,
    messageId
}: {
    messageId: string;
    handleChange?: (messageId: string, changedText: string) => void;
    messageText: string;
}) => {
    const { t } = useTranslation('common');
    const [originalText, setOriginalText] = useState<string>(null);

    const { translatePlugin, getTranslateLanguageOptions, setTargetLanguage, targetLanguage } = usePluginStore();

    const languageOptions = getTranslateLanguageOptions();
    if (!translatePlugin || !languageOptions?.length) {
        return null;
    }
    return (
        <>
            <Divider style={{ marginBlock: '5px' }} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'nowrap', gap: '5px' }}>
                {originalText && (
                    <Button
                        size="small"
                        onClick={() => {
                            if (originalText) {
                                handleChange(messageId, originalText);
                                setOriginalText(null);
                            }
                        }}
                    >
                        {t('plugin.translate.backToOriginal')}
                    </Button>
                )}
                <Popover
                    placement="topRight"
                    arrow={{ pointAtCenter: true }}
                    content={
                        <Space>
                            <Typography.Text>{t('plugin.translate.translateTo')}</Typography.Text>
                            <Select
                                style={{ width: '150px' }}
                                options={languageOptions ? (languageOptions as any[]) : null}
                                value={targetLanguage}
                                onChange={(value) => setTargetLanguage(value)}
                                showSearch
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                    (option?.label ?? '')
                                        .toLocaleLowerCase('tr')
                                        .includes(input.toLocaleLowerCase('tr'))
                                }
                            />
                        </Space>
                    }
                >
                    <Button
                        size="small"
                        onClick={async () => {
                            if (handleChange) {
                                const changedText = await getTranslatedText(
                                    (messageText as any)?.props?.dirtyHtml ?? messageText,
                                    targetLanguage
                                )
                                    .then((trans) => {
                                        return trans?.map((translation) => translation.translatedText).join('-');
                                    })
                                    .catch((error) => {
                                        const limitKey = (error as any)?.response?.data?.limitKey;
                                        const feature = Object.keys(subscriptionFeatureMap).find(
                                            (feature) => typeof limitKey === 'string' && limitKey.includes(feature)
                                        );
                                        if (feature) {
                                            grispiSubscriptionModal({ feature: subscriptionFeatureMap[feature] });
                                            return;
                                        }
                                        grispiNotification(
                                            'error',
                                            error?.response?.data?.message || error?.message,
                                            'translate-error'
                                        );
                                    });
                                handleChange(messageId, changedText);
                                !originalText && setOriginalText((messageText as any)?.props?.dirtyHtml ?? messageText);
                            }
                        }}
                    >
                        {t('plugin.translate.translateButtonText')}
                    </Button>
                </Popover>
            </div>
        </>
    );
};

export default observer(ChatMessageTranslateDropDown);
